"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _AwyesContext = require("../context/AwyesContext");

var usePages = function usePages() {
  var _useContext = (0, _react.useContext)(_AwyesContext.store),
      pages = _useContext.pages,
      currentPage = _useContext.currentPage,
      setCurrentPage = _useContext.setCurrentPage;

  return [{
    pages: pages,
    currentPage: currentPage
  }, {
    setCurrentPage: setCurrentPage
  }];
};

var _default = usePages;
exports["default"] = _default;